import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the scroll position to the very top of the document on every route
 * change. Works alongside the Lenis-powered SmoothScroll wrapper by also
 * resetting the Lenis instance exposed on `window.__lenis` (see SmoothScroll).
 *
 * Skips the reset when navigating to an in-page anchor (#section).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // allow in-page anchor scrolling

    // Reset Lenis (smooth-scroll) state if it's mounted
    const lenis = typeof window !== "undefined" ? window.__lenis : null;
    if (lenis && typeof lenis.scrollTo === "function") {
      lenis.scrollTo(0, { immediate: true, force: true });
    }

    // Belt-and-braces hard reset for non-Lenis pages / mobile
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
    if (typeof document !== "undefined") {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }, [pathname, hash]);

  return null;
}
